import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { serviceOpsShipmentActions } from '../../../_actions';
import { BookingsInput } from './BookingsInput';
import ReactCountryFlag from "react-country-flag"

export function BookingsInputContainer({ handleClose }) {
    const [tabValue, setTabValue] = useState(0);
    const state = useSelector(state => state.serviceOpsShipment);
    const countries = useSelector(state => state.instantPricing).countries;
    const goodsState = useSelector(state => state.ShipmentInformationForm.data);

    const row = state.data.rows.find((row) => row.id === state.selectedShipment.Id);
    const purchasePrice = row ? row.purchasePrice : null;

    const carrierOptions = state.carrierOptions.map(carrier => ({
        value: carrier.id,
        label: carrier.name,
    }));

    const dispatch = useDispatch();

    const handleSetTabValue = (event, newValue) => setTabValue(newValue);

    const countryOptions = countries.map((x) => ({
        value: x.alpha2,
        label: <React.Fragment key={x.name}>
            <span><ReactCountryFlag svg countryCode={x.alpha2} width="20" /></span>
            <span style={{ marginLeft: '10px' }}>{x.name}</span>
        </React.Fragment>
    }));

    const handleBasicInfoChange = (event) => {
        dispatch(serviceOpsShipmentActions.updateBasicValue(event.target.name, event.target.value));
    };

    const handleGoodsRowChange = (event, index) => {
        dispatch(serviceOpsShipmentActions.updateGoodsLine(event.target.name, event.target.value, index));
    };

    const handleLocationChange = (event, index) => {
        dispatch(serviceOpsShipmentActions.updateLocationValue(event.target.name, event.target.value, index));
    };

    const addGoodsLine = () => {
        dispatch(serviceOpsShipmentActions.addGoodsLine());
    };

    const removeGoodsLine = (index) => {
        dispatch(serviceOpsShipmentActions.removeGoodsLine(index));
    };

    const saveBillingDetails = () => {
        const billingInformation = {
            shipmentId: state.selectedShipment.id,
            price: state.selectedShipment.purchasePrice,
            priceType: 2,
            productCode: 0,
        };
        dispatch(serviceOpsShipmentActions.saveBillingDetails(state.selectedShipment, billingInformation));
    };

    const addPricingDetail = (pricingDetailName, pricingDetailPrice) => {
        dispatch(serviceOpsShipmentActions.addPricingDetailToState(pricingDetailName, pricingDetailPrice));
    };

    const addAdditionalService = (additionalService, additionalServiceValue) => {
        dispatch(serviceOpsShipmentActions.addAdditionalService(additionalService.value, additionalService.label, additionalServiceValue));
    };

    const handleDeleteAdditionalService = (id, type) => {
        dispatch(serviceOpsShipmentActions.deleteAdditionalServiceRow(id, type));
    };

    const handleDeletePricingDetail = (id, type) => {
        dispatch(serviceOpsShipmentActions.deletePricingDetailRow(id, type));
    };

    const handleCopyContentClick = (index) => {
        const location = state.selectedShipment.locations[index];
        const stringToCopy = location.name + '\n' + location.streetAddress + '\n' + location.zip + ', ' + location.city + '\n' + location.country + '\n\n' + location.contactName + '\n' + location.contactPhone + '\n' + location.contactEmail;
        navigator.clipboard.writeText(stringToCopy);
    };

    const handleBookingUpdate = () => {
        const model = {
            ...state.selectedShipment,
            selectedCarrier: state.selectedShipment.carrier.label,
            selectedCarrierId: state.selectedShipment.carrier.value,
            locations: state.selectedShipment.locations.map(location => ({
                ...location,
                country: {
                    Id: location.countryId,
                    Name: location.country,
                    Alpha2: location.countryAlpha2
                }
            }))
        };
        dispatch(serviceOpsShipmentActions.updateShipment(model));
        handleClose();
    };

    return (
        <BookingsInput
            state={state}
            tabValue={tabValue}
            handleSetTabValue={handleSetTabValue}
            carrierOptions={carrierOptions}
            countryOptions={countryOptions}
            purchasePrice={purchasePrice}
            goodsState={goodsState}
            handleBasicInfoChange={handleBasicInfoChange}
            handleGoodsRowChange={handleGoodsRowChange}
            handleLocationChange={handleLocationChange}
            addGoodsLine={addGoodsLine}
            removeGoodsLine={removeGoodsLine}
            saveBillingDetails={saveBillingDetails}
            addPricingDetail={addPricingDetail}
            addAdditionalService={addAdditionalService}
            handleDeleteAdditionalService={handleDeleteAdditionalService}
            handleDeletePricingDetail={handleDeletePricingDetail}
            handleCopyContentClick={handleCopyContentClick}
            handleBookingUpdate={handleBookingUpdate}
            handleClose={handleClose}
        />
    );
} 